<template>
  <FeedFilterTag v-if="type === CATEGORY_TYPE.ESHOP" :on-click="handleClick">
    {{ parameter?.name || '' }}: {{ value }}
  </FeedFilterTag>
</template>

<script setup>
import _ from 'lodash-es';
import { parameterValueLabel } from '@utils/parameters';
import { CATEGORY_TYPE } from "@utils/constants";
import { useEnumStore } from '@stores/enum';
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  type: {
    type: String,
    default: 'eshop'
  }
});

const route = useRoute();
const enums = useEnumStore();

const parameter = computed(() => _.find(enums.eshopParameters || [], { id: props.data.idParameter }));
const value = computed(() => parameterValueLabel(props.data, parameter.value));

const handleClick = async () => {
  const params = { ...route.query };
  const queryKey = `p[${props.data.idParameter}]`;
  if (props.data.idValue == null) {
    await useSearchParam(queryKey, '');
    return;
  }
  await useSearchParam(queryKey, _.chain(params[queryKey] || '').split(',').filter(idValue => parseInt(idValue) !== props.data.idValue).join(',').value());
}

</script>
